// extracted by mini-css-extract-plugin
export default {"wrapper":"SignUpHandler_wrapper__s-58o","button":"SignUpHandler_button__IGwi+ Typography_fontBody__caCnz Typography_text__WxJ-h","login":"SignUpHandler_login__qFddB"};